import { getPaymentTypeLabel } from './payment-type'
import { trackClickCtaEvent } from './track-click-cta'

export type PaymentInfoInteraction = 'click' | 'hover'

export type PaymentInfoPayload = {
  /** Adyen txVariant of the wallet shown as first badge, e.g. `applepay`. */
  walletType: 'applepay' | 'googlepay'
  experimentId?: string
  variationId?: string
}

export function trackPaymentInfo(interaction: PaymentInfoInteraction, payload: PaymentInfoPayload) {
  trackClickCtaEvent({
    action: `${interaction} - payment info`,
    type: 'experience',
    payment_type: getPaymentTypeLabel({ type: payload.walletType }),
    experiment_id: payload.experimentId,
    variation_id: payload.variationId,
  })
}
